module.exports = {
  entry: './src/apps/codb-game/index.tsx',
  shortcode: 'codb-game',
  title: 'CODB Game',
  status: 'stable',
  description:
    'The CODB (Cost of Data Breach) Game widget has a quiz format of 10 random questions covering data security essentials, pop culture references, and IBM’s Cost of a Data Breach report itself to promote the 2024 report.',
  preview: {
    url: `${process.env.PUBLIC_URL}/storybook/iframe.html?id=widgets-codb-game-components--default&viewMode=story`,
  },
  useExternalPeerDependencies: ['react', 'react-dom', 'react-intl'],
  additionalCustomProperties: {
    webSegmentPaths: ['/cloud', '/products', '/flashsystem'],
    availableTranslations: ['en'],
  },
};
